// App
export const SAMPLE_ACTION_TYPE = 'SAMPLE_ACTION_TYPE';

// Posts
export const FETCH_POSTS = 'FETCH_POSTS';
